module.exports = __webpack_public_path__ + "img/signup-carousel-sixth@2x.66ab525a.png";